/**
 * Workshop version of LinkedinFrame.
 */
import { Icons } from "@/components/ui/icons";
import { cn } from "@/lib/cn";
import { FrameHeader } from "@/workshop/components/shapes/shared/frame-header";

interface LinkedinFrameProps {
  postText?: string;
  tags?: string[];
  charCount?: string;
  title?: string;
  agentName?: string;
  onPublish?: () => void;
  onResizeStart?: React.MouseEventHandler;
  className?: string;
  "data-testid"?: string;
}

export function LinkedinFrame({
  postText = "AI agents are reshaping how teams work in 2026.\n\nHere are 3 patterns I've observed:\n\n1. Autonomous research loops\n2. Multi-agent collaboration\n3. Human-in-the-loop approval\n\nThe key insight? It's not about replacing...",
  tags = ["#AI", "#Agents", "#Future"],
  charCount = "847/3000 characters",
  title = "AI in 2026 Post",
  agentName = "Social",
  onResizeStart: _onResizeStart,
  className,
  "data-testid": testId = "linkedin-frame",
}: LinkedinFrameProps) {
  return (
    <div className={cn("denker-glass-frame flex flex-col rounded-frame overflow-hidden", className)} data-testid={testId}>
      <FrameHeader title={title} icon={Icons.Linkedin} accentColor="bg-frame-linkedin" agentName={agentName} data-testid={`${testId}-header`} />
      <div className="flex flex-1 flex-col gap-1.5 p-2 overflow-hidden">
        <p className="flex-1 whitespace-pre-wrap text-canvas-sm leading-[1.4] text-secondary line-clamp-10" data-testid={`${testId}-text`}>{postText}</p>
        <div className="flex flex-wrap gap-0.5" data-testid={`${testId}-tags`}>
          {tags.map((tag) => (
            <span key={tag} className="rounded bg-[#312E81] px-1 py-0.5 text-canvas-2xs text-[#A5B4FC]">{tag}</span>
          ))}
        </div>
        <span className="text-canvas-2xs text-muted">{charCount}</span>
      </div>
    </div>
  );
}

export type { LinkedinFrameProps };
